<template>
  <div>
    <oil-cap
        title="Инвойсы"
        :buttons="[{name:'создать Инвойс',route:'importer-invoice'}]"
    />
    <v-divider class="my-2"/>
    <oil-table
        :keys="keys"
        :items="invoices"
        :paginate='count'
        @paginateAction='paginate'
        :rowClick="rowClick"
    >
      <template v-slot:Status="{value}">
        <v-chip color="success" v-text="value"/>
      </template>
      <template v-slot:Id="{value}">
        <v-btn icon>
          <v-icon color="primary" v-text="'mdi-pen'"/>
        </v-btn>
      </template>
    </oil-table>
  </div>
</template>

<script>
import {coreApi} from "~/services/core";

export default {
  components: {
    OilCap: () => import('@/components/helper/oil.cap'),
    OilTable: () => import('@/components/helper/oil.table'),
  },
  data: () => ({
    keys: [
      {
        text: 'Импортер',
        value: 'Importer'
      },
      {
        text: 'Номер',
        value: 'Number'
      },
      {
        text: 'Товар',
        value: 'ProductName'
      },
      {
        text: 'Количество',
        value: 'QuantityTons'
      }
    ],
    invoices: [],
    count:{
      count:0
    }
  }),
  async created() {
    await this.paginate((this.currentPage - 1) * 10)

    // const invoices = await coreApi.get('importer-invoice')
    // this.invoices = invoices.data?.map(invoice => {
    //   return {
    //     Id: invoice?.Id,
    //     Importer: invoice?.Importer?.Name,
    //     Number: invoice?.Number,
    //     ProductName: invoice?.Product?.Name,
    //     QuantityTons: invoice?.QuantityTons,
    //   }
    // }) || []
  },
  methods: {
    rowClick({Id}) {
      this.$router.push({
        name: 'importer-invoice',
        params: {id: Id}
      })
    },
    async paginate(page) {
      const invoices = await coreApi.get(`importer-invoice/${page}`)
      const { count, dates } = invoices.data
      this.count.count = count
      this.invoices = dates?.map(invoice => {
        return {
          Id: invoice?.Id,
          Importer: invoice?.Importer?.Name,
          Number: invoice?.Number,
          ProductName: invoice?.Product?.Name,
          QuantityTons: invoice?.QuantityTons,
        }
      })
    },
  }
}
</script>